export const API_URL = 'https://trc3.tpsre.api.dsml.ru/'
export const CONFIRMATION_GENERATOR_ID = '5a9685b6-4aad-4050-8709-3251b3ca6a0d'
export const EMAIL_CONFIRMATION_GENERATOR_ID = '311adce4-9184-4f52-b951-e345a0170018'
export const PERSONAL_DATA_CONSENT_ID = '02c37051-ba0c-4842-b17f-e22fc81b1164'
export const COMMUNICATIONS_CONSENT_ID = '086e4543-dd17-44d3-b378-fe0f57a2f07d'
export const RULES_CONSENT_ID = '086e4543-dd17-44d3-b378-fe0f57a2f07d'
export default API_URL



// WEBPACK FOOTER //
// ./src/common/config.js